/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreativeCommons = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM9 9c.706 0 1.376.247 1.908.684l.155.137-1.373 1.454a1 1 0 1 0-.115 1.543l.096-.076 1.339 1.485A3 3 0 1 1 9 9zm6 0c.706 0 1.376.247 1.908.684l.155.137-1.373 1.454a1 1 0 1 0-.115 1.543l.096-.076 1.339 1.485A3 3 0 1 1 15 9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCreativeCommons as CreativeCommons };
